import { render, staticRenderFns } from "./RegionList.vue?vue&type=template&id=0961524e&scoped=true"
import script from "./RegionList.vue?vue&type=script&lang=js"
export * from "./RegionList.vue?vue&type=script&lang=js"
import style0 from "./RegionList.vue?vue&type=style&index=0&id=0961524e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0961524e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0961524e')) {
      api.createRecord('0961524e', component.options)
    } else {
      api.reload('0961524e', component.options)
    }
    module.hot.accept("./RegionList.vue?vue&type=template&id=0961524e&scoped=true", function () {
      api.rerender('0961524e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/systemSet/RegionList.vue"
export default component.exports